import http from './http-service'
import config from '../config/constant'

export const getAllBillers = async (data) => {
  try {
    const reqParams = {
      requestId: 'GETALLBILLERS',
      ...data,
    }
    const response = await http.post(config.billers.getAllBillers, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getBillerBeneficiaries = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.billers.getBillerBeneficiaries, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const addBillerBeneficiary = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'ADDBILLERBENE',
    }
    const response = await http.post(config.billers.addBiller, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const deleteBillerBeneficiary = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DELETEBILLERBENE"
    }
    const response = await http.post(config.billers.deleteBillerBene, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getBillQuote = async (data) => {
    try {
      const reqParams = {
        ...data,
        requestId: "GETQUOTEID"
      }
      const response = await http.post(config.approvals.getBillQuote, reqParams)
      return { status: response.status, data: response.data }
    } catch (err) {
      return Promise.reject(err)
    }
  }

  export const billPaymentInitiate = async (data) => {
    try {
      const reqParams = {
        ...data,
        requestId: "BILLPAYMENT"
      }
      const response = await http.post(config.billers.billPaymentInitiate, reqParams)
      return { status: response.status, data: response.data }
    } catch (err) {
      return Promise.reject(err)
    }
  }

  const getServiceById = async (data) => {
    try {
      const reqParams = {
        ...data,
        module: 'BILL',
        requestId: 'GETALLBILLERS',
      }
      const response = await http.post(config.billers.getServiceById, reqParams)
      return { status: response.status, data: response.data }
    } catch (err) {
      throw err.response.data
    }
  }
  
const getPendingBills = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: 'BILL',
      requestId: 'GETALLBILLERS',
    }
    const response = await http.post(config.billers.getPendingBills, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getAllBanks = async () => {
  try {
    const reqParams = {
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.getAllBanks, reqParams)
    return response.data //.bankList
  } catch (err) {
    throw err.response.data
  }
}


const PaymentsService = {
  getAllBillers,
  getBillerBeneficiaries,
  addBillerBeneficiary,
  deleteBillerBeneficiary,
  getBillQuote,
  billPaymentInitiate,
  getServiceById,
  getPendingBills,
  getAllBanks
}

export default PaymentsService
